module.exports = __webpack_public_path__ + "static/media/vk_icon.44021628.svg";